import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

/**
 * Single notification row: type, description, timestamp, optional unread dot.
 * Light blue background, rounded corners.
 */
const NotificationItem = ({ type, description, timeAgo, isUnread = true, onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      position: 'relative',
      p: 1.5,
      borderRadius: 1.5,
      bgcolor: '#EBF5FF',
      transition: 'background-color 0.2s',
      '&:hover': {
        bgcolor: 'action.hover',
      },
      cursor: 'pointer',
    }}
  >
    {isUnread && (
      <Box
        sx={{
          position: 'absolute',
          top: 12,
          right: 12,
          width: 8,
          height: 8,
          borderRadius: '50%',
          bgcolor: '#2666BE',
        }}
      />
    )}
    <Typography
      variant="subtitle2"
      sx={{
        fontWeight: 700,
        color: 'text.primary',
        pr: isUnread ? 2 : 0,
      }}
    >
      {type}
    </Typography>
    <Typography
      variant="body2"
      sx={{
        color: 'text.primary',
        mt: 0.25,
        pr: isUnread ? 2 : 0,
      }}
    >
      {description}
    </Typography>
    <Typography
      variant="caption"
      sx={{
        display: 'block',
        mt: 0.5,
        color: 'text.secondary',
      }}
    >
      {timeAgo}
    </Typography>
  </Box>
)

export default NotificationItem
